export default "__VITE_ASSET__4Z2TqhOx__"